<template>
  <div>
    <Nav />
    <section class="section" id="Main" role="main">
      <div class="container">
        <h2 class="title is-2">Pedagogical Framework</h2>
        <div class="box">
          <h3 class="title is-3">Step One: Content Standards and Instructional Goals</h3>
          <div class="content">
            <ol>
              <li>Identify the TEKS your lesson or unit addresses</li>
              <li>Identify your instructional goal(s) for the lesson or unit</li>
            </ol>
          </div>
        </div>

        <div class="box">
          <h3 class="title is-3">Step Two: Addressing Texas Slavery</h3>
          <div class="content">
            <ol>
              <li>How does instruction address soul value?</li>
              <li>How does instruction make use of records and documents?</li>
              <li>
                How does instruction draw from best practices in social studies teaching?
                <ol type="a">
                  <li>Historical inquiry</li>
                  <li>Document based analysis</li>
                  <li>Perspective-taking</li>
                  <li>Civics, culture, and context</li>
                </ol>
              </li>
            </ol>
          </div>
        </div>

        <div class="box">
          <h3 class="title is-3">Step Three: Addressing Race</h3>
          <div class="content">
            <ol>
              <li>What critical perspective(s) about race does the lesson draw from and/or address?</li>
              <li>How is race approached as a socially constructed idea that has equitably impacted our society in tangible ways?</li>
              <li>How is Texas slavery presented as a racialized system that advanced the interests and power of Whiteness (and persons)?</li>
            </ol>
          </div>
        </div>

        <div class="box">
          <h3 class="title is-3">Step Four: Instructional Practices</h3>
          <div class="content">
            <ol>
              <li>How is instruction presented in a humanizing way that considers the positionalities of African American/Black students and their experiences with the content? What, if any are particular positionalities or contexts that need additional consideration?</li>
              <li>How is instruction enacted in a way that values and allows for improvisation, acknowledges context, and draws from the all-encompassing nature of curriculum and teaching?</li>
            </ol>
          </div>
        </div>
        <router-link class="button is-primary is-medium next-button" :to="{name:'documents'}" aria-label="View the primary source documents">
          <span>View Documents</span>
          <span class="icon is-small">
            <i class="fas fa-arrow-right"></i>
          </span>
        </router-link>
      </div>
    </section>
    <Footer />
  </div>
</template>

<script>
// import Header from './components/Header.vue'
import Nav from "./components/Nav.vue";
import Footer from "./components/Footer.vue";

export default {
  name: "Framework",
  components: {
    Nav,
    Footer
  }
};
</script>

<style scoped>
</style>